var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12"}},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"cols":"12"}},[_c('Timeline',{attrs:{"eventId":_vm.eventId,"expanded":true,"toggable":false,"entity":"Channel"}})],1)],1),_c('v-tour',{attrs:{"name":"overview-tour","steps":_vm.steps,"callbacks":_vm.callbacks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }